import { PlatformScopeProvider } from '@/lib/platform-scope';
import { BillsPage, FinanceCategoriesPage, PayablesPage, ReceivablesPage } from '@/modules/finance';

/**
 * O financeiro de quem administra o SaaS - as mesmas telas do salao,
 * apontadas para a empresa da propria plataforma. Cada tela e uma pagina
 * propria no menu, como no salao - nao uma aba.
 */
export function SaasFinanceCategoriesPage() {
  return (
    <PlatformScopeProvider prefix="/saas/financeiro">
      <FinanceCategoriesPage />
    </PlatformScopeProvider>
  );
}

export function SaasBillsPage() {
  return (
    <PlatformScopeProvider prefix="/saas/financeiro">
      <BillsPage />
    </PlatformScopeProvider>
  );
}

export function SaasPayablesPage() {
  return (
    <PlatformScopeProvider prefix="/saas/financeiro">
      <PayablesPage />
    </PlatformScopeProvider>
  );
}

export function SaasReceivablesPage() {
  return (
    <PlatformScopeProvider prefix="/saas/financeiro">
      <ReceivablesPage />
    </PlatformScopeProvider>
  );
}
